let plek_user = {

    default_button_texts: {},


    construct() {

        plek_user.default_button_texts.submit = jQuery('#user-settings-submit').text();
        //On Submitbutton click
        jQuery('#plek-submit').click(function (e) {
            e.preventDefault();
            let type = jQuery(this).data('type');
            plek_user.submit(type);
        });

        //on register Input click
        jQuery('#register-new-user input[type!="submit"]').click(function () {
            //reset Button status
            jQuery('#plek-submit').val(plek_user.default_button_texts.submit);
        })
        //On disable all notification checkbox
        jQuery('#ps_setting_disable_all_notifications').click(function (e) {
            plek_user.deactivate_setting(this);
        });
        plek_user.deactivate_setting(jQuery('#ps_setting_disable_all_notifications')[0]);

        //on settings submit input click
        jQuery('#plek-user-settings-form button').click(function (e) {
            e.preventDefault();
            //Check if cancel button
            if (e.currentTarget.id === 'user-settings-cancel') {
                var prev_url = (!empty(e.currentTarget.dataset.referer)) ? e.currentTarget.dataset.referer : document.referrer;
                //Try to remove the activation key of the url.
                //@todo: Remove the unlock parameter as well. For some reason, this does not work...
                /*if (typeof URLSearchParams !== 'undefined' && prev_url.includes('?')) {
                    var params = new URLSearchParams(prev_url)
                    params.delete('key');
                    params.delete('unlock'); //Not working??
                    prev_url = unescape(params.toString());
                }*/
                location.href = prev_url;
                return;
            }
            plek_user.save_user_settings();
        })
    },

    /**
     * Deactivates or activates all notification settings, if the master 
     * disable all notifications checkbox was clicked.
     * @param {HTMLInputElement} checkbox - The master checkbox element
     */
    deactivate_setting(checkbox) {
        const checked_status = checkbox?.checked ?? false;
        if (checked_status) {
            jQuery('.notification-setting').each((index, item) => {
                if (item.id !== 'ps_setting_disable_all_notifications') {
                    jQuery(item).closest('article').addClass('deactivated');
                }
            });
        } else {
            jQuery('.notification-setting').closest('article').removeClass('deactivated');
        }
    },

    /**
     * Sending a user form
     * @param {string} type 
     * @returns void
     */
    submit(type) {
        switch (type) {
            case "log-in":
                this.log_in_user();
                break;
            case "add-user-account":
                this.add_user_account();
                break;
            case "resetpassword":
                this.reset_password();
                break;
            case "set_new_password":
                this.set_new_password();
                break;

            default:
                console.log("Submit Type not found: " + type);
                break;
        }
        return;
    },


    /**
     * Submits the add-user-account form
     * @returns {Promise<void>}
     */
    async add_user_account() {
        let button = jQuery('#plek-submit');
        const data = new FormData(document.getElementById('register-new-user-form'));
        data.append('action', 'plek_user_actions');
        data.append('do', 'add_user_account');

        const captcha_token = await this.get_recaptcha_response(button);
        data.append('recaptcha_token', captcha_token);
        data.append('security', plek_vars.plek_nonce);

        plek_main.send_form(data, button, 'register-new-user-form');
    },



    /**
     * Submits the login form
     * @returns {Promise<void>}
     */
    async log_in_user() {
        let button = jQuery('#plek-submit');
        const data = new FormData();
        data.append('action', 'plek_user_actions');
        data.append('do', 'login_user');
        data.append('user', plek_main.get_text_from_id('user_login'));
        data.append('password', plek_main.get_text_from_id('user_pass'));
        data.append('remember', plek_main.get_text_from_id('rememberme'));
        data.append('2fa', plek_main.get_text_from_id('user_2fa'));

        const captcha_token = await this.get_recaptcha_response(button);
        data.append('recaptcha_token', captcha_token);
        data.append('security', plek_vars.plek_nonce);

        return plek_main.send_form(data, button, 'loginform', plek_main.form_success_callback, this.on_user_login_error);
    },

    /**
     * Called when the user login fails. It shows the errors to the user.
     * If the error is related to 2FA, it also shows the 2FA input field.
     * @param {object} response - The response object from the Ajax request.
     * @param {string} button_id - The ID of the button that triggered the form submission.
     * @param {string} form_id - The ID of the form that was submitted.
     */
    on_user_login_error(response, button_id, form_id) {
        plek_main.form_error_callback(response, button_id);
        const first_error = plek_main.get_first_error_from_ajax_request(response);
        if (first_error.indexOf('2FA') !== -1) {
            const login2fa = document.querySelector('.login-2fa');
            if (login2fa) login2fa.style.display = 'block';
        }
    },

    /**
     * Get the recaptcha response from the button.
     * @param {Object} button - The button with the recaptcha data-sitekey attribute.
     * @returns {Promise<string>} - The response from the recaptcha service.
     */
    async get_recaptcha_response(button) {
        let key = jQuery(button).data('sitekey');
        return new Promise((resolve, reject) => {
            grecaptcha.ready(function () {
                return grecaptcha.execute(key, { action: 'submit' })
                    .then(token => resolve(token))
                    .catch(error => reject(error))
            });
        });
    },

    /**
     * Resets the password for the user.
     * Sends a form request to the server with the user_login, user_pass.
 
     * @returns {undefined}
     */
    reset_password() {
        let button = jQuery('#plek-submit');

        const data = new FormData(document.getElementById('lostpasswordform'));
        data.append('action', 'plek_user_actions');
        data.append('do', 'reset_password');
        plek_main.send_form(data, button, 'lostpasswordform');
        return;
    },

    /**
     * Set the new password for the user
     * @todo: Replace with send form
     * @returns 
     */
    set_new_password() {
        let button = jQuery('#plek-submit');

        const data = new FormData(document.getElementById('set_new_password_form'));
        data.append('action', 'plek_user_actions');
        data.append('do', 'set_new_password');
        plek_main.send_form(data, button, 'set_new_password_form');
        return;
    },


    /**
     * Saves the user settings by submitting the form data.
     * Collects form data from the specified form element and sends it to the server
     * using an asynchronous request.
     * @returns {void}
     */

    save_user_settings() {
        const button = jQuery('#user-settings-submit');
        const form_id = 'plek-user-settings-form';
        let data = new FormData(document.querySelector('#' + form_id));
        data.append('action', 'plek_user_actions');
        data.append('do', 'save_user_settings');
        data.set('description', plekevent.get_field_value('description'));

        //Workaround to get the values from tomselect
        jQuery('#' + form_id + ' select.tomselect').each((index, item) => {
            data.set(item.id, item.tomselect?.getValue());
        });

        data = plek_main.get_checkbox_inputs(data, form_id);

        plek_main.send_form(data, button, form_id);
    },

    reset_button_text_after_input_focus(button, text) {
        jQuery('input').focus(function () {
            jQuery(button).text(text);
        });
    }

}
plek_user.construct();